<div class="btnsContainer">
  <div class="text-center">
    <ul class="list-inline">
      <li class="list-inline-item">
        <div
          class="layoutBox Layout12 pointer"
          [ngClass]="selected === 1 ? 'selected' : 'notSelected'"
          (click)="selectLayout(1)"
        >
          <div class="row noPadding">
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
          </div>
          <div class="space5"></div>
          <div class="row noPadding">
            <div class="col-md-12 noPadding">
              <div class="columnBox"></div>
            </div>
          </div>
        </div>
      </li>
      <li class="list-inline-item">
        <div
          class="layoutBox Layout6 pointer"
          [ngClass]="selected === 2 ? 'selected' : 'notSelected'"
          (click)="selectLayout(2)"
        >
          <div class="row noPadding">
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
          </div>
          <div class="space5"></div>
          <div class="row noPadding">
            <div class="col-md-6 noPadding">
              <div class="columnBox"></div>
            </div>
            <div class="col-md-6 noPadding">
              <div class="columnBox"></div>
            </div>
          </div>
        </div>
      </li>
      <li class="list-inline-item">
        <div
          class="layoutBox Layout48 pointer"
          [ngClass]="selected === 4 ? 'selected' : 'notSelected'"
          (click)="selectLayout(4)"
        >
          <div class="row noPadding">
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
          </div>
          <div class="space5"></div>
          <div class="row noPadding">
            <div class="col-md-4 noPadding">
              <div class="columnBox"></div>
            </div>
            <div class="col-md-8 noPadding">
              <div class="columnBox"></div>
            </div>
          </div>
        </div>
      </li>
      <li class="list-inline-item">
        <div
          class="layoutBox Layout4 pointer"
          [ngClass]="selected === 3 ? 'selected' : 'notSelected'"
          (click)="selectLayout(3)"
        >
          <div class="row noPadding">
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
          </div>
          <div class="space5"></div>
          <div class="row noPadding">
            <div class="col-md-4 noPadding">
              <div class="columnBox"></div>
            </div>
            <div class="col-md-4 noPadding">
              <div class="columnBox"></div>
            </div>
            <div class="col-md-4 noPadding">
              <div class="columnBox"></div>
            </div>
          </div>
        </div>
      </li>
      <li class="list-inline-item">
        <div
          class="layoutBox Layout84 pointer"
          [ngClass]="selected === 5 ? 'selected' : 'notSelected'"
          (click)="selectLayout(5)"
        >
          <div class="row noPadding">
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
            <div class="col-md-3 noPadding">
              <div class="childBox"></div>
            </div>
          </div>
          <div class="space5"></div>
          <div class="row noPadding">
            <div class="col-md-8 noPadding">
              <div class="columnBox"></div>
            </div>
            <div class="col-md-4 noPadding">
              <div class="columnBox"></div>
            </div>
            ​
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
